import type { ApiResponse, QuestionnaireSession, QuestionnaireDefinition } from '@klaro7/shared-types';

import api from '@/lib/api';

export async function getQuestionnaireSession(token: string): Promise<QuestionnaireSession> {
  const response = await api.get<ApiResponse<QuestionnaireSession>>(`/questionnaire/${token}`);
  return response.data.data;
}

export async function saveQuestionnaireStep(
  token: string,
  step: number,
  answers: Record<string, unknown>,
): Promise<QuestionnaireSession> {
  const response = await api.put<ApiResponse<QuestionnaireSession>>(
    `/questionnaire/${token}/step/${step}`,
    answers,
  );
  return response.data.data;
}

export async function uploadQuestionnairePhoto(
  token: string,
  file: File,
): Promise<{ url: string }> {
  const formData = new FormData();
  formData.append('photo', file);

  const response = await api.post<ApiResponse<{ url: string }>>(
    `/questionnaire/${token}/upload-photo`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data.data;
}

export async function getPublicQuestionnaireDefinition(): Promise<QuestionnaireDefinition> {
  const response = await api.get<ApiResponse<QuestionnaireDefinition>>('/questionnaire/definition');
  return response.data.data;
}
